import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IWhoIsThisProgramFor {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  desktop_background_color?: string;
  mobile_background_color?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  variant?: string;
  pre_title?: string;
  pre_title_color?: string;
  title?: string;
  title_start_color?: string;
  title_end_color?: string;
  title_gradient_angle?: string;
  description?: string;
  description_color?: string;
  cta_color?: string;
  cta_text?: string;
  cta_text_color?: string;
  metadata?: Array<{
    id?: number | string;
    meta_title?: string;
    meta_title_color?: string;
    meta_title_hover_color?: string;
    meta_description?: string;
    meta_description_color?: string;
    meta_image?: string;
    meta_priority?: number;
  }>;
  status?: boolean;
}

export async function createWhoIsThisProgramFor(payload: Partial<IWhoIsThisProgramFor>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.WHO_IS_THIS_PROGRAM_FOR.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateWhoIsThisProgramFor(id: number, payload: Partial<IWhoIsThisProgramFor>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.WHO_IS_THIS_PROGRAM_FOR.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
